/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import React, { FC, PropsWithChildren, useMemo } from 'react';

import { OverlayTrigger, TriggerType } from '../../OverlayTrigger';
import { Tooltip } from '../../Tooltip';
import { generateId } from '../../util/utils';

interface Props extends PropsWithChildren {
    caption: React.ReactNode;
    triggerType?: TriggerType;
}

export const Tip: FC<Props> = ({ caption, children, triggerType }) => {
    const id = useMemo(() => generateId('tip-'), []);
    return (
        <OverlayTrigger
            delay={200}
            id={id}
            overlay={
                <Tooltip id={id} placement="top">
                    {caption}
                </Tooltip>
            }
            triggerType={triggerType}
        >
            {children}
        </OverlayTrigger>
    );
};
Tip.displayName = 'Tip';
